import styled from 'styled-components';

import { Chip } from '@sorare/core/src/atoms/ui/Chip';

import {
  DIAMOND_HEIGHT,
  DIAMOND_WIDTH,
} from '#src/components/series/SeriesBoard/utils.ts';

export const TileWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${DIAMOND_WIDTH}px;
  height: ${DIAMOND_HEIGHT}px;
`;
export const CroppedPlayerImage = styled.div`
  position: absolute;
  top: -51%;
  width: 100px;
  height: 100px;
  clip-path: polygon(15% 0%, 15% 81.17%, 50% 99.89%, 84% 81.17%, 84% 0%);
`;
export const LiveChip = styled(Chip)`
  position: absolute;
  top: calc(-1 * var(--quadruple-unit));
  left: 80%;
  color: var(--c-red-400);
`;
export const Dot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--c-red-400);
`;

export const greenOverlay =
  'linear-gradient(to top, #00F34D 10%, transparent 35%)';

export const redOverlay =
  'linear-gradient(to top, #721717 10%, transparent 35%)';

export const orangeOverlay =
  'linear-gradient(to top, #FF4E22 10%, transparent 35%)';
